import { graphConfig } from './authConfig';

export async function callMsGraph(accessToken: string) {
	const headers = new Headers();
	const bearer = `Bearer ${accessToken}`;

	headers.append('Authorization', bearer);

	const options = {
		method: 'GET',
		headers: headers,
	};

	return fetch(graphConfig.graphMeEndpoint, options)
		.then((response) => {
			return response.json();
		})
		.catch((error) => {
			console.log(error);
			throw error;
		});
}

/**
 * Fetches the signed-in user's profile photo from Microsoft Graph and returns it
 * as a base64 data URL (so it can be persisted in the store / localStorage).
 * Returns null when the user has no photo set (Graph responds 404).
 */
export async function callMsGraphPhoto(accessToken: string): Promise<string | null> {
	const headers = new Headers();
	headers.append('Authorization', `Bearer ${accessToken}`);

	const response = await fetch(graphConfig.graphPhotoEndpoint, {
		method: 'GET',
		headers,
	});

	if (!response.ok) {
		// 404 = no photo set for this user; anything else we also treat as "no photo".
		return null;
	}

	const blob = await response.blob();

	return await new Promise<string>((resolve, reject) => {
		const reader = new FileReader();
		reader.onloadend = () => {
			return resolve(reader.result as string);
		};

		reader.onerror = reject;
		reader.readAsDataURL(blob);
	});
}
